query reviewerOptions($filter: UserFilterInput) {
  base {
    users(filter: $filter) {
      items {
        id
        username
        name
        lastName
        __typename
      }
      pageInfo {
        hasNextPage
        page
        size
        total
        __typename
      }
      __typename
    }
    __typename
  }
}
